export default __webpack_public_path__ + "static/bg_ios14-4834fd25f0f029b85b8090afab91da5a.png";